import "./vite-require-shim.js";
import "./i18n";

const _origError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && args[0].includes("findDOMNode is deprecated")) return;
  _origError(...args);
};

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import {
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
} from "@mui/material/styles";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#3f51b5",
      contrastText: '#fff',
    },
    secondary: {
      main: "#2ca8ff",
      contrastText: '#fff',
    },
    gray: {
      main: "#e0e0e0",
      contrastText: '#000',
    },
  },
});

// styles for this kit
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/nucleo-icons-page-styles.css";
import "assets/css/custom.css";

// pages for this kit
import Index from "views/Index.js";
import LoginPage from "views/screens/LoginPage.js";
import SignUpPage from "views/screens/SignUp.js";
import ResetPassword from "views/screens/ResetPasswordPage";
import DashboardPage from "views/screens/DashboardPage";
import PatientDashboard from "views/screens/PatientDashboard";
import LogisticsDashboard from "views/screens/LogisticsDashboard";
import LabLogisticsDashboard from "views/screens/LabLogisticsDashboard";
import Users from "views/screens/user/index.js";
import Admin from "views/screens/admin/index.js";
import Products from "views/screens/products/index.js";
// import Receives from "views/screens/receive/index.js";
import Reports from "views/screens/report/index.js";
import Patients from "views/screens/patients/index.js";
import Protocol from "views/screens/protocol/index.js";
import Regimen from "views/screens/regimen/index.js";
import Prescription from "views/screens/prescription/index.js";
import Dispenser from "views/screens/dispenser/index.js";
import Prescriber from "views/screens/prescriber/index.js";
import StockStatus from "views/screens/stock_status/index.js";
import Order from "views/screens/order/index.js";
import OrderApproval from "views/screens/order_approval/index.js";
import Receive from "views/screens/receive/index.js";
import Dispense from "views/screens/dispense/index.js";
import Issue from "views/screens/issue/index.js";
import LabTestEntry from "views/screens/labtestentry/index.js";
import TestAppointmentEntry from "views/screens/testappointmententry/index.js";
import TestAppointment from "views/screens/testappointment/index.js";
import MissedAppointmentTestReport from "views/screens/missedappointmenttestreport/index.js";
import LabDailyDispenseStatus from "views/screens/labdailydispensestatus/index.js";
import OfferofEachTestExpectedCompletedReport from "views/screens/offerofeachtestexpectedcompletedreport/index.js";
import Adjustment from "views/screens/adjustment/index.js";
import Repacking from "views/screens/repacking/index.js";
import StockTake from "views/screens/stock_take/index.js";
import Uom from "views/screens/uom/index.js";
//direction
import Directions from "views/screens/direction/index.js";
//Interval
import Intervals from "views/screens/interval/index.js";
//Interval
import Labtests from "views/screens/labtest/index.js";
import Labtestlist from "views/screens/labtestlist/index.js";
//Rute of admin
import Routeofadmin from "views/screens/routeofadmin/index.js";

//Order type list
import Ordertypelists from "views/screens/ordertypelist/index.js";
//Title list
import TitleLists from "views/screens/titlelist/index.js";
import CohortType from "views/screens/cohorttype/index.js";
//maritalstatus list
import Maritalstatus from "views/screens/maritalstatus/index.js";
//ABC list
import Abcs from "views/screens/abc/index.js";
import Location from "views/screens/location/index.js";
import EmailSmsTemplate from "views/screens/email_sms_template_entry/index.js";

import Role from "views/screens/roleentryfrom/index.js";
import Menuentry from "views/screens/menuentry/index.js";
import Roleaccessentry from "views/screens/roleaccessentry/index.js";
import PostEntry from "views/screens/post_entry/index.js";
import Specialisation from "views/screens/specialisation/index.js";

import AdjustmentType from "views/screens/adjustment_type/index.js";
import LanguagePreference from "views/screens/language_preference/index.js";
import PackSize from "views/screens/pack_size/index.js";
import Form from "views/screens/form/index.js";
import Strength from "views/screens/strength/index.js";
import UiLanguage from "views/screens/ui_language/index.js";
import Facility from "views/screens/facility/index.js";
import UserEntry from "views/screens/user_entry/index.js";
import MonthClose from "views/screens/month_close/index.js";
import LabQuarterClose from "views/screens/lab_quarter_close/index.js";
import PatientImport from "views/screens/patient_import/index.js";
import Generics from "views/screens/generics/index.js";
import MOSRange from "views/screens/mos_range/index.js";
import ATC from "views/screens/atc/index.js";
import Source from "views/screens/source/index.js";
import AgeGroup from "views/screens/AgeGroup/index.js";

import StockSummary from "views/screens/StockSummary";
import LabStockSummary from "views/screens/LabStockSummary";
import LMISReport from "views/screens/LMISReport";
import LabLMISReport from "views/screens/LabLMISReport";
import LaboratoryActivityReport from "views/screens/LaboratoryActivityReport";
import LaboratoryActivityDetailsReportbyPatients from "views/screens/LaboratoryActivityDetailsReportbyPatients";
import ProductsNearingExpiryReport from "views/screens/ProductsNearingExpiryReport";
import LabProductsNearingExpiryReport from "views/screens/LabProductsNearingExpiryReport";
import LtfuBackReport from "views/screens/LtfuBackReport";
import PreEPPatientsReport from "views/screens/PreEPPatientsReport";
import PatientReportUnderIO from "views/screens/PatientReportUnderIO";
import LtfuLostToSightReport from "views/screens/LtfuLostToSightReport";
import MissedAppointmentswithDaysPrecisionReport from "views/screens/MissedAppointmentswithDaysPrecisionReport";
import KeyPopulationsActiveQueueReport from "views/screens/KeyPopulationsActiveQueueReport";
import InformationSheetForPLHIVPatientsOnINHProphylaxis from "views/screens/InformationSheetForPLHIVPatientsOnINHProphylaxis";
import PatientStatusReport from "views/screens/PatientStatusReport";

import ConsumptionTrendsForTheTopFiveProducts from "views/screens/ConsumptionTrendsForTheTopFiveProducts";
import ConsumptionTrendsForTheTopFiveLabProducts from "views/screens/ConsumptionTrendsForTheTopFiveLabProducts";
import StockStatusDetails from "views/screens/StockStatusDetails";
import LabStockStatusDetails from "views/screens/LabStockStatusDetails";
import AMCTrendsforTheTopFiveProducts from "views/screens/AMCTrendsforTheTopFiveProducts";
import AMCTrendsforTheTopFiveLabProducts from "views/screens/AMCTrendsforTheTopFiveLabProducts";
import PercentageOfFacilitiesWithAStockoutOfTracerCommodities from "views/screens/PercentageOfFacilitiesWithAStockoutOfTracerCommodities";
import LabPercentageOfFacilitiesWithAStockoutOfTracerCommodities from "views/screens/LabPercentageOfFacilitiesWithAStockoutOfTracerCommodities";
import AvailabilityOfCommodities from "views/screens/AvailabilityOfCommodities";
import AvailabilityOfLabCommodities from "views/screens/AvailabilityOfLabCommodities";

import MyProfile from "views/screens/myprofile/index.js";

import AdultPatientsByProtocol from "views/screens/AdultPatientsByProtocol";
import PaediatricPatientsByProtocol from "views/screens/PaediatricPatientsByProtocol";
import TrendofActivePatients from "views/screens/TrendofActivePatients";
import TldUptake from "views/screens/TldUptake";
import TldTransitionTrend from "views/screens/TldTransitionTrend";
import MmdAmongAdults from "views/screens/MmdAmongAdults";
import MmdAmongPaediatrics from "views/screens/MmdAmongPaediatrics";
import MmdCoverageBysite from "views/screens/MmdCoverageBysite";
import YearEntry from "views/screens/year_entry/index.js";

import TldStockstatus from "views/screens/TldStockstatus";
import Patientcoinfectionentry from "views/screens/patientcoinfectionentry";
import Keypopulationtypeentry from "views/screens/keypopulationtypeentry";
import Errorlog from "views/screens/error-log/index.js";
import Auditlog from "views/screens/audit-log/index.js";
import MailSMSLog from "views/screens/mail-sms-log/index.js";
import SMSLog from "views/screens/sms-log/index.js";
import ExternalAPIDataTransferLog from "views/screens/external-api-data-transfer-log/index.js";

import DataExtractTool from "views/screens/data_extract_tool/index.js";

import StockStatusSOBAPS from "views/screens/stock_status_sobaps/index.js";
import IssueDetails from "views/screens/issuedetails/index.js";



import UserContextProvider from "./context/user-info-context";
import CheckPermission from "views/screens/CheckPermission.js";

import packageJson from "../package.json";
import swal from "sweetalert";

import { QueryClient, QueryClientProvider, useQuery } from "@tanstack/react-query";

const queryClient = new QueryClient();

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

let userInfo = null;

//if (selFacility != null) {
userInfo = {
  FacilityId: 0,
  FacilityName: "CHUZ-SURU-LERE",
  LangId: "fr_FR",
};

//////////////////////////////////////////////////////////

const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });

  setTimeout(function () {
    window.location.reload();
  }, 1000);
};

if (localStorage.getItem("sw_Version") == null) {
  swal({
    title: "",
    text:
      "Une nouvelle version de l'application est disponible" +
      ", Version-" +
      process.env.REACT_APP_SW_Version,
    icon: "warning",
    button: "Rafraîchir",
    showCancelButton: false,
    showConfirmButton: false,
  }).then((willDelete) => {
    if (willDelete) {
      localStorage.setItem("sw_Version", process.env.REACT_APP_SW_Version);
      window.location.href = `${process.env.REACT_APP_BASE_NAME}`;
      clearCacheData();
    }
  });
} else if (localStorage.getItem("sw_Version") < process.env.REACT_APP_SW_Version) {
  swal({
    title: "",
    text:
      "Une nouvelle version de l'application est disponible, appuyez sur Rafraîchir pour mettre à jour à partir de [" +
      localStorage.getItem("sw_Version") +
      "] à [" +
      process.env.REACT_APP_SW_Version +
      "]",
    icon: "warning",
    button: "Rafraîchir",
    showCancelButton: false,
    showConfirmButton: false,
  }).then((willDelete) => {
    if (willDelete) {
      localStorage.setItem("sw_Version", process.env.REACT_APP_SW_Version);
      window.location.href = `${process.env.REACT_APP_BASE_NAME}`;
      clearCacheData();
    }
  });
}

/////////////////////////////////////

const rootEl = document.getElementById("root");
const root = createRoot(rootEl);
root.render(
  <StyledEngineProvider injectFirst>
  <ThemeProvider theme={muiTheme}>
  <UserContextProvider userInfo={userInfo}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
        <CompatRouter>
        <Suspense>
          <Switch>
            <Route path="/home" render={(props) => <Index {...props} />} />
            <Route path="/login" render={(props) => <LoginPage {...props} />} />
            <Route
              path="/signup"
              render={(props) => <SignUpPage {...props} />}
            />
            <Route
              path="/reset-password"
              render={(props) => <ResetPassword {...props} />}
            />
            <Route
              path="/dashboard"
              render={(props) => <DashboardPage {...props} />}
            />
            <Route
              path="/patient-dashboard"
              render={(props) => <PatientDashboard {...props} />}
            />
            <Route
              path="/logistics-dashboard"
              render={(props) => <LogisticsDashboard {...props} />}
            />
            <Route
              path="/lab-logistics-dashboard"
              render={(props) => <LabLogisticsDashboard {...props} />}
            />
            <Route path="/users" render={(props) => <Users {...props} />} />
            <Route path="/admin" render={(props) => <Admin {...props} />} />
            <Route
              path="/products"
              render={(props) => <Products {...props} />}
            />
            {/* <Route path="/receives" render={(props) => <Receives {...props} />} /> */}

            <Route path="/report" render={(props) => <Reports {...props} />} />
            <Route
              path="/patients"
              render={(props) => <Patients {...props} />}
            />
            <Route
              path="/protocol"
              render={(props) => <Protocol {...props} />}
            />
            <Route path="/regimen" render={(props) => <Regimen {...props} />} />
            <Route
              path="/prescription"
              render={(props) => <Prescription {...props} />}
            />
            <Route
              path="/dispenser"
              render={(props) => <Dispenser {...props} />}
            />
            <Route
              path="/prescriber"
              render={(props) => <Prescriber {...props} />}
            />
            <Route
              path="/stock-status"
              render={(props) => <StockStatus {...props} />}
            />
            <Route path="/order" render={(props) => <Order {...props} />} />
            <Route
              path="/order-approval"
              render={(props) => <OrderApproval {...props} />}
            />
            <Route path="/receive" render={(props) => <Receive {...props} />} />
            <Route
              path="/dispense"
              render={(props) => <Dispense {...props} />}
            />
            <Route path="/issue" render={(props) => <Issue {...props} />} />
            <Route
              path="/entry-of-the-results-of-the-various-assessments-for-the-patients"
              render={(props) => <LabTestEntry {...props} />}
            />
            <Route
              path="/test-appointment-entry"
              render={(props) => <TestAppointmentEntry {...props} />}
            />
            <Route
              path="/test-appointment"
              render={(props) => <TestAppointment {...props} />}
            />
            <Route
              path="/missed-appointment-test-report"
              render={(props) => <MissedAppointmentTestReport {...props} />}
            />
            <Route
              path="/lab-daily-dispense-status"
              render={(props) => <LabDailyDispenseStatus {...props} />}
            />
            <Route
              path="/offer-of-each-test-expected-and-completed-report"
              render={(props) => (
                <OfferofEachTestExpectedCompletedReport {...props} />
              )}
            />
            <Route
              path="/adjustment"
              render={(props) => <Adjustment {...props} />}
            />
            <Route
              path="/repacking"
              render={(props) => <Repacking {...props} />}
            />
            <Route
              path="/stock-take"
              render={(props) => <StockTake {...props} />}
            />
            <Route
              path="/unit-of-measure-entry-form"
              render={(props) => <Uom {...props} />}
            />
            <Route
              path="/direction-entry"
              render={(props) => <Directions {...props} />}
            />
            <Route
              path="/interval-entry"
              render={(props) => <Intervals {...props} />}
            />
            <Route
              path="/labtest-entry"
              render={(props) => <Labtests {...props} />}
            />
            <Route
              path="/lab-test-list"
              render={(props) => <Labtestlist {...props} />}
            />
            <Route
              path="/route-of-admin-entry"
              render={(props) => <Routeofadmin {...props} />}
            />
            
            <Route
              path="/order-type-list-entry"
              render={(props) => <Ordertypelists {...props} />}
            />
            <Route
              path="/title-list-entry"
              render={(props) => <TitleLists {...props} />}
            />
            <Route
              path="/cohort-type"
              render={(props) => <CohortType {...props} />}
            />
            <Route
              path="/marital-status-entry"
              render={(props) => <Maritalstatus {...props} />}
            />
            <Route path="/abc-entry" render={(props) => <Abcs {...props} />} />
            <Route
              path="/location-entry"
              render={(props) => <Location {...props} />}
            />
            <Route
              path="/email-sms-template-entry"
              render={(props) => <EmailSmsTemplate {...props} />}
            />
            <Route path="/role-entry" render={(props) => <Role {...props} />} />
            <Route
              path="/menu-entry"
              render={(props) => <Menuentry {...props} />}
            />
            <Route
              path="/role-access-entry"
              render={(props) => <Roleaccessentry {...props} />}
            />
            <Route
              path="/post-entry"
              render={(props) => <PostEntry {...props} />}
            />
            <Route
              path="/specialisation"
              render={(props) => <Specialisation {...props} />}
            />
            
            <Route
              path="/adjustment-type"
              render={(props) => <AdjustmentType {...props} />}
            />
            <Route
              path="/language-preference"
              render={(props) => <LanguagePreference {...props} />}
            />
            <Route
              path="/pack-size"
              render={(props) => <PackSize {...props} />}
            />
            <Route path="/form" render={(props) => <Form {...props} />} />
            <Route
              path="/strength"
              render={(props) => <Strength {...props} />}
            />
            <Route
              path="/ui-language"
              render={(props) => <UiLanguage {...props} />}
            />
            <Route
              path="/facility"
              render={(props) => <Facility {...props} />}
            />
            <Route
              path="/user-entry"
              render={(props) => <UserEntry {...props} />}
            />
            <Route
              path="/month-close"
              render={(props) => <MonthClose {...props} />}
            />
            <Route
              path="/lab-quarter-close"
              render={(props) => <LabQuarterClose {...props} />}
            />
            <Route
              path="/patient-import"
              render={(props) => <PatientImport {...props} />}
            />
            <Route
              path="/generics"
              render={(props) => <Generics {...props} />}
            />
            <Route
              path="/mos-range"
              render={(props) => <MOSRange {...props} />}
            />
            <Route path="/atc-entry" render={(props) => <ATC {...props} />} />
            <Route
              path="/source-entry"
              render={(props) => <Source {...props} />}
            />
            <Route
              path="/agegroup-entry"
              render={(props) => <AgeGroup {...props} />}
            />

            <Route
              path="/stock-summary"
              render={(props) => <StockSummary {...props} />}
            />
            <Route
              path="/lab-stock-summary"
              render={(props) => <LabStockSummary {...props} />}
            />
            <Route
              path="/lmis-report"
              render={(props) => <LMISReport {...props} />}
            />
            <Route
              path="/lab-lmis-report"
              render={(props) => <LabLMISReport {...props} />}
            />
            <Route
              path="/laboratory-activity-report"
              render={(props) => <LaboratoryActivityReport {...props} />}
            />
            <Route
              path="/laboratory-activity-details-report-by-patients"
              render={(props) => (
                <LaboratoryActivityDetailsReportbyPatients {...props} />
              )}
            />
            <Route
              path="/products-nearing-expiry-report"
              render={(props) => <ProductsNearingExpiryReport {...props} />}
            />
            <Route
              path="/lab-products-nearing-expiry-report"
              render={(props) => <LabProductsNearingExpiryReport {...props} />}
            />
            <Route
              path="/ltfu-back-report"
              render={(props) => <LtfuBackReport {...props} />}
            />
            <Route
              path="/preep-patients-report"
              render={(props) => <PreEPPatientsReport {...props} />}
            />
            <Route
              path="/patient-report-under-io"
              render={(props) => <PatientReportUnderIO {...props} />}
            />
            <Route
              path="/ltfu-lost-to-sight-report"
              render={(props) => <LtfuLostToSightReport {...props} />}
            />
            <Route
              path="/missed-appointments-with-days-precision-report"
              render={(props) => (
                <MissedAppointmentswithDaysPrecisionReport {...props} />
              )}
            />
            <Route
              path="/key-populations-active-queue-report"
              render={(props) => <KeyPopulationsActiveQueueReport {...props} />}
            />
            <Route
              path="/information-sheet-for-plhiv-patients-on-inh-prophylaxis"
              render={(props) => (
                <InformationSheetForPLHIVPatientsOnINHProphylaxis {...props} />
              )}
            />
            <Route
              path="/patient-status"
              render={(props) => <PatientStatusReport {...props} />}
            />
            <Route
              path="/consumption-trends-for-the-top-five-products"
              render={(props) => (
                <ConsumptionTrendsForTheTopFiveProducts {...props} />
              )}
            />
            <Route
              path="/consumption-trends-for-the-top-five-lab-products"
              render={(props) => (
                <ConsumptionTrendsForTheTopFiveLabProducts {...props} />
              )}
            />
            <Route
              path="/stock-status-details"
              render={(props) => <StockStatusDetails {...props} />}
            />
            <Route
              path="/lab-stock-status-details"
              render={(props) => <LabStockStatusDetails {...props} />}
            />
            <Route
              path="/amc-trends-for-the-top-five-products"
              render={(props) => <AMCTrendsforTheTopFiveProducts {...props} />}
            />
            <Route
              path="/amc-trends-for-the-top-five-lab-products"
              render={(props) => (
                <AMCTrendsforTheTopFiveLabProducts {...props} />
              )}
            />
            <Route
              path="/percentage-of-facilities-with-a-stockout-of-tracer-commodities"
              render={(props) => (
                <PercentageOfFacilitiesWithAStockoutOfTracerCommodities
                  {...props}
                />
              )}
            />
            <Route
              path="/percentage-of-facilities-with-a-stockout-of-lab-tracer-commodities"
              render={(props) => (
                <LabPercentageOfFacilitiesWithAStockoutOfTracerCommodities
                  {...props}
                />
              )}
            />
            <Route
              path="/availability-of-commodities"
              render={(props) => <AvailabilityOfCommodities {...props} />}
            />
            <Route
              path="/availability-of-lab-commodities"
              render={(props) => <AvailabilityOfLabCommodities {...props} />}
            />

            <Route
              path="/my-profile"
              render={(props) => <MyProfile {...props} />}
            />

            <Route
              path="/adult-patients-by-protocol"
              render={(props) => <AdultPatientsByProtocol {...props} />}
            />
            <Route
              path="/paediatric-patients-by-protocol"
              render={(props) => <PaediatricPatientsByProtocol {...props} />}
            />
            <Route
              path="/trend-of-active-patients"
              render={(props) => <TrendofActivePatients {...props} />}
            />
            <Route
              path="/tld-uptake"
              render={(props) => <TldUptake {...props} />}
            />
            <Route
              path="/tld-transition-trend"
              render={(props) => <TldTransitionTrend {...props} />}
            />
            <Route
              path="/mmd-among-adults"
              render={(props) => <MmdAmongAdults {...props} />}
            />
            <Route
              path="/mmd-among-paediatrics"
              render={(props) => <MmdAmongPaediatrics {...props} />}
            />
            <Route
              path="/mmd-coverage-by-site"
              render={(props) => <MmdCoverageBysite {...props} />}
            />
            <Route
              path="/year_entry"
              render={(props) => <YearEntry {...props} />}
            />
            <Route
              path="/tld-stock-status"
              render={(props) => <TldStockstatus {...props} />}
            />
            <Route
              path="/patient-co-infection-entry"
              render={(props) => <Patientcoinfectionentry {...props} />}
            />
            <Route
              path="/key-population-type-entry"
              render={(props) => <Keypopulationtypeentry {...props} />}
            />
            <Route
              path="/error-log"
              render={(props) => <Errorlog {...props} />}
            />
            <Route
              path="/audit-log"
              render={(props) => <Auditlog {...props} />}
            />
            <Route
              path="/mail-sms-log"
              render={(props) => <MailSMSLog {...props} />}
            />
             <Route
              path="/sms-log"
              render={(props) => <SMSLog {...props} />}
            />
            <Route
              path="/external-api-data-transfer-log"
              render={(props) => <ExternalAPIDataTransferLog {...props} />}
            />
            <Route
              path="/data-extract-tool"
              render={(props) => <DataExtractTool {...props} />}
            />


            <Route
              path="/stock-status-sobaps"
              render={(props) => <StockStatusSOBAPS {...props} />}
            />
             <Route
              path="/issue-details"
              render={(props) => <IssueDetails {...props} />}
            />

            <Route
              path="/check-permission"
              render={(props) => <CheckPermission {...props} />}
            />
            <Route path="/" render={(props) => <Index {...props} />} />
          </Switch>
        </Suspense>
        </CompatRouter>
      </BrowserRouter>
    </QueryClientProvider>
  </UserContextProvider>
  </ThemeProvider>
  </StyledEngineProvider>
);
